import * as types from '../../../../lib/actionTypes.es6'

export function getGroupPaymentsRequest(payload) {
  return {
    type: types.GET_GROUP_PAYMENTS_REQUEST,
    payload: payload || {}
  }
}

export function getGroupPaymentsSuccess(payload) {
  return {
    type: types.GET_GROUP_PAYMENTS_SUCCESS,
    payload
  }
}

export function getGroupPaymentsFailure(error) {
  return {
    type: types.GET_GROUP_PAYMENTS_FAILURE,
    payload: error
  }
}

export function getGroupPaymentRequest(payload) {
  return {
    type: types.GET_GROUP_PAYMENT_REQUEST,
    payload
  }
}

export function getGroupPaymentSuccess(payload) {
  return {
    type: types.GET_GROUP_PAYMENT_SUCCESS,
    payload
  }
}

export function getGroupPaymentFailure(error) {
  return {
    type: types.GET_GROUP_PAYMENT_FAILURE,
    payload: error
  }
}

export function updateGroupPaymentStatusRequest(payload) {
  return {
    type: types.UPDATE_GROUP_PAYMENT_STATUS_REQUEST,
    payload
  }
}

export function updateGroupPaymentStatusSuccess(payload) {
  return {
    type: types.UPDATE_GROUP_PAYMENT_STATUS_SUCCESS,
    payload
  }
}

export function updateGroupPaymentStatusFailure(error) {
  return {
    type: types.UPDATE_GROUP_PAYMENT_STATUS_FAILURE,
    payload: error
  }
}

export function updateGroupPaymentStatusReset() {
  return { type: types.UPDATE_GROUP_PAYMENT_STATUS_RESET }
}

// payload: { groupGuids: [], userIds: [] }
export function resolveOmkPaymentLabelsRequest(payload) {
  return {
    type: types.RESOLVE_OMK_PAYMENT_LABELS_REQUEST,
    payload
  }
}

// payload: { groups: { guid: name }, users: { id: name } } — best effort, so
// there is no failure action; anything that could not be resolved is simply
// absent and the UI falls back to the raw identifier.
export function resolveOmkPaymentLabelsSuccess(payload) {
  return {
    type: types.RESOLVE_OMK_PAYMENT_LABELS_SUCCESS,
    payload
  }
}
